// モックアップ共有（doc/design/pm-mockup.md）
export default {
  'mockup.tab': '效果圖',
  'mockup.empty': '尚無效果圖',
  'mockup.chip.internal': '僅內部',
  'mockup.chip.shared': '分享中',
  'mockup.chip.sharedUntil': '分享中 · 至 {date}',
  'mockup.col.title': '標題',
  'mockup.col.linked': '關聯對象',
  'mockup.col.version': '版本',
  'mockup.col.share': '分享',
  'mockup.col.updated': '更新',
  'mockup.linked.task': '任務',
  'mockup.linked.bug': 'Bug',
  'mockup.linked.project': '僅專案',
  'mockup.deleteConfirm': '刪除「{title}」嗎？',
  'mockup.deleteHint': '所有版本都會被刪除，分享連結也會失效。',
  'mockup.edit.title': '編輯效果圖',
  'mockup.edit.task': '關聯任務',
  'mockup.edit.taskHint': '留空則掛在整個專案上。內容的修改請作為新版本發佈。',
  'mockup.edit.clearBug': '解除與 Bug {bug} 的關聯',
  'mockup.field.title': '標題',
  'mockup.field.titlePlaceholder': '留空則使用 HTML 的 title 標籤',
  'mockup.field.note': '版本說明',
  'mockup.field.notePlaceholder': '例：依客戶回饋增加保留狀態',
  'mockup.page.title': '效果圖',
  'mockup.page.titleOf': '{name} · 效果圖',
  'mockup.page.subtitle':
    '管理用 Claude Code 等產生的 HTML 效果圖版本，並分享給客戶與業務',
  'mockup.page.sharedOnly': '只看分享中',
  'mockup.page.upload': '上傳 HTML / zip',
  'mockup.page.entry': '效果圖一覽',
  'mockup.upload.title': '發佈效果圖',
  'mockup.upload.newVersion': '上傳新版本',
  'mockup.upload.publish': '發佈',
  'mockup.upload.drop': '拖入 HTML 或 zip 檔案，或點擊選擇',
  'mockup.upload.hint': '.html（最大 5MB）或含圖片等資源的 .zip（最大 50MB）',
  'mockup.upload.needFile': '請選擇 HTML 或 zip 檔案',
  'mockup.upload.done': '已發佈 v{v}',
  'mockup.upload.error.type': '只能上傳 .html 或 .zip 檔案',
  'mockup.upload.error.size':
    '不能上傳超過 5MB 的 HTML，請將圖片等資源拆出並打包成 zip',
  'mockup.upload.error.zipSize': '不能上傳超過 50MB 的 zip',
  'mockup.upload.error.empty': '檔案為空',
  'mockup.viewer.close': '關閉',
  'mockup.viewer.desktop': '桌面',
  'mockup.viewer.tablet': '平板',
  'mockup.viewer.phone': '手機',
  'mockup.viewer.openTab': '新分頁開啟',
  'mockup.viewer.newVersion': '新版本',
  'mockup.viewer.share': '分享…',
  'mockup.viewer.loading': '載入中…',
  'mockup.viewer.slow': '載入時間較長，請稍候。',
  'mockup.version.files': '{n} 個檔案',
  'mockup.version.title': '版本',
  'mockup.version.deleteConfirm': '刪除 v{v} 嗎？',
  'mockup.version.deleteHint': '刪除目前版本後，剩餘的最新版本會成為目前版本。',
  'mockup.version.shareLatest': '分享連結總是顯示最新版本。',
  'mockup.version.sharePinned': '分享連結固定顯示 v{v}。',
  'mockup.version.notShared': '尚未開啟分享連結。',
  'mockup.share.title': '分享「{title}」',
  'mockup.share.enable': '開啟分享連結',
  'mockup.share.offHint': '開啟後會產生無需登入即可查看的連結（預設 30 天）。',
  'mockup.share.link': '連結（無需登入）',
  'mockup.share.copy': '複製',
  'mockup.share.copied': '已複製',
  'mockup.share.copyFailed': '複製失敗',
  'mockup.share.expiry': '有效期限',
  'mockup.share.days7': '7 天',
  'mockup.share.days30': '30 天',
  'mockup.share.never': '無期限',
  'mockup.share.until': '至 {date}',
  'mockup.share.noExpiry': '無期限',
  'mockup.share.version': '對方看到的版本',
  'mockup.share.latest': '總是最新',
  'mockup.share.pinTo': '固定為 v{v}',
  'mockup.share.views': '已開啟 {n} 次 · 最近 {last}',
  'mockup.share.regenerate': '重新產生連結',
  'mockup.share.regenerateConfirm': '重新產生連結嗎？',
  'mockup.share.regenerateHint': '目前連結會立即失效，請把新連結重新寄給對方。',
  'mockup.share.regenerated': '已產生新連結',
  'mockup.share.done': '完成',
  'mockup.public.invalid': '此連結已失效，請聯絡負責人。',
  'mockup.public.version': '版本 {v} · {date} 更新',
  'mockup.public.validUntil': '{date} 前有效',
};
